import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { ThemeModeComponent } from '../../../shared/components/header/theme-mode/theme-mode.component';

@Component({
  selector: 'app-superadmin-login',
  imports: [LoaderComponent, RouterModule, LoginFormComponent, ThemeModeComponent],
  templateUrl: './superadmin-login.component.html',
  styleUrl: './superadmin-login.component.scss'
})
export class SuperadminLoginComponent {
  public isLoading: boolean = false;
  constructor(

  ) { }

}
